import React, { useRef, useState } from "react";
import {
  Popover,
  PopoverTrigger,
  PopoverContent,
  Listbox,
  ListboxItem,
  ListboxSection,
  Avatar,
} from "@nextui-org/react";
import Confirmlogout from "./ConFirmlogout.js";
import { useLocation, useNavigate } from "react-router-dom";
import { IoMdHome } from "react-icons/io";
import { RiLogoutCircleRLine } from "react-icons/ri";
import { useSelector } from "react-redux";
import { selectUser } from "../../../redux/selectors/userSelectors.js";
import { MdAdminPanelSettings } from "react-icons/md";
import { checkPermissions } from "../../../utils/getRolesAndPermissions.js";

export default function Profile() {
  const user = useSelector(selectUser);
  const [isLogin, setIsLogin] = useState({ data: "", isLogged: false });
  const btnRef = useRef();
  const listBtnRef = useRef();
  const navigate = useNavigate();
  const location = useLocation(); // Ensure location is at the top

  // Handlers for navigation
  const logoutbtnClk = () => {
    btnRef.current?.click();
    listBtnRef.current?.click();
  };

  const goHomeClick = () => {
    listBtnRef.current?.click();
    navigate("/");
  };

  const goAdmins = () => {
    listBtnRef.current?.click();
    navigate("/setting/users");
  };

  return (
    <>
      <Popover placement="bottom" className="!rounded-[3px] mr-1">
        <PopoverTrigger>
          <div className="scale-95">
            <Avatar
              className="shadow"
              as="button"
              src={user?.profileImage || ""} // If no image, fallback to empty
              showFallback
              classNames={{
                icon: "text-black/50",
              }}
              ref={listBtnRef}
            />
          </div>
        </PopoverTrigger>

        <PopoverContent className="!rounded-[3px]">
          <Listbox variant="faded" aria-label="Listbox menu with icons">
            {/* User info */}
            <ListboxItem
              className="hover:!border-transparent p-0 m-0 cursor-text !bg-transparent"
              textValue="Signed in as"
            >
              <div className="p-0 m-0">
                <div className="text-base font-semibold">Signed in as</div>
                <div className="line-clamp-1">
                  {user?.email || "user@example.com"}
                </div>
              </div>
            </ListboxItem>

            {/* Actions */}
            {(checkPermissions("DASHBOARD", true) ||
              checkPermissions("USER_MANAGEMENT_VIEW", true)) && (
                <ListboxSection title="Actions" className="border-b pb-1">
                  {checkPermissions("DASHBOARD", true) && (
                    <ListboxItem
                      className={` rounded-md mb-1 ${location.pathname.includes("/dashboard")
                        ? "bg-[#2344d650]"
                        : ""
                        }`}
                      key="dashboard"
                      startContent={<IoMdHome className="text-xl" />}
                      textValue="dashboard"
                      onClick={goHomeClick}
                    >
                      <div className="!text-xs !font-semibold">Dashboard</div>
                    </ListboxItem>
                  )}
                  {checkPermissions("USER_MANAGEMENT_VIEW", true) && (
                    <ListboxItem
                      className={` rounded-md ${location.pathname.includes("/setting/users")
                        ? "bg-[#2344d650]"
                        : ""
                        }`}
                      key="manageadmin"
                      startContent={<MdAdminPanelSettings className="text-xl" />}
                      textValue="manageadmin"
                      onClick={goAdmins}
                    >
                      <div className="!text-xs !font-semibold">Manage Users</div>
                    </ListboxItem>
                  )}
                </ListboxSection>
              )}


            {/* Logout */}
            <ListboxSection title={"Danger zone"}>
              <ListboxItem
                key="logout"
                className="text-danger !border !border-red-500"
                color="danger"
                description="Logout from browser"
                startContent={<RiLogoutCircleRLine className="text-xl" />}
                textValue="Logout"
                onClick={logoutbtnClk}
              >
                Logout
              </ListboxItem>
            </ListboxSection>
          </Listbox>
        </PopoverContent>
      </Popover>

      {/* Logout confirmation dialog */}
      <Confirmlogout
        btnRef={btnRef}
        setIsLogin={setIsLogin}
        isLogin={isLogin}
      />
    </>
  );
}
